@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import com.varabyte.kobweb.browser.http.http
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Suppress
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.dom.hasClass
import kotlinx.dom.removeClass
import org.jetbrains.compose.web.renderComposable
import org.w3c.dom.EventSource
import org.w3c.dom.EventSourceInit
import org.w3c.dom.MessageEvent
import org.w3c.dom.`get`
import com.merkost.handpass.admin.pages.FeatureFlagsPage as _com_merkost_handpass_admin_pages_FeatureFlagsPage
import com.merkost.handpass.admin.pages.ImagesPage as _com_merkost_handpass_admin_pages_ImagesPage
import com.merkost.handpass.admin.pages.ListingDetailPage as _com_merkost_handpass_admin_pages_ListingDetailPage
import com.merkost.handpass.admin.pages.ListingsPage as _com_merkost_handpass_admin_pages_ListingsPage
import com.merkost.handpass.admin.pages.LogsPage as _com_merkost_handpass_admin_pages_LogsPage
import com.merkost.handpass.admin.pages.ModerationRedirectPage as _com_merkost_handpass_admin_pages_ModerationRedirectPage
import com.merkost.handpass.admin.pages.PartnerListingsPage as _com_merkost_handpass_admin_pages_PartnerListingsPage
import com.merkost.handpass.admin.pages.QueuePage as _com_merkost_handpass_admin_pages_QueuePage
import com.merkost.handpass.admin.pages.ReportsRedirectPage as _com_merkost_handpass_admin_pages_ReportsRedirectPage
import com.merkost.handpass.admin.pages.StatsPage as _com_merkost_handpass_admin_pages_StatsPage
import com.merkost.handpass.admin.pages.UserDetailPage as _com_merkost_handpass_admin_pages_UserDetailPage
import com.merkost.handpass.admin.pages.UsersPage as _com_merkost_handpass_admin_pages_UsersPage

private fun forceReloadNow() {
    window.stop()
    window.location.reload()
}

private fun handleServerStatusEvents() {
    val status = document.getElementById("status")!!
    var lastVersion: Int? = null
    var shouldReload = false

    val warningIcon = status.children[0]!!
    val spinnerIcon = status.children[1]!!
    val statusText = status.children[2]!!

    status.addEventListener("transitionend", {
        if (status.hasClass("fade-out")) {
            status.removeClass("fade-out")
            if (shouldReload) {
                forceReloadNow()
            }
        }
    })

    val eventSource = EventSource("/api/kobweb-status", EventSourceInit(true))
    eventSource.addEventListener("version", { evt ->
        val version = (evt as MessageEvent).data.toString().toInt()
        if (lastVersion == null) {
            lastVersion = version
        }
        if (lastVersion != version) {
            lastVersion = version
            if (document.asDynamic().hidden) {
                // Reload immediately when the page is not visible as the animation will not run
                forceReloadNow()
            } else if (status.className.isNotEmpty()) {
                shouldReload = true
            } else {
                // Not sure if we can get here but if we can't rely on the status transition
                // to reload we should do it ourselves.
                forceReloadNow()
            }
        }
    })

    eventSource.addEventListener("status", { evt ->
        val values: dynamic = JSON.parse<Any>((evt as MessageEvent).data.toString())
        val text = values.text as String
        val isError = (values.isError as String).toBoolean()
        if (text.isNotBlank()) {
            warningIcon.className = if (isError) "visible" else "hidden"
            spinnerIcon.className = if (isError) "hidden" else "visible"
            statusText.innerHTML = "<i>$text</i>"
            status.className = "fade-in"
        } else {
            if (status.className == "fade-in") {
                status.className = "fade-out"
            }
        }
    })

    eventSource.onerror = { eventSource.close() }
}

public fun main() {
    handleServerStatusEvents()

    window.http.logOnError = true

    AppGlobals.initialize(mapOf("title" to "Handpass Admin", "admin.apiBaseUrl" to "https://api.handpass.co", "admin.supabaseUrl" to "https://oxjbfwfwnuvxrxzxmmva.supabase.co", "admin.supabaseAnonKey" to "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im94amJmd2Z3bnV2eHJ4enhtbXZhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjYyNTYxMTksImV4cCI6MjA4MTgzMjExOX0.LHbmnpYNJmpkWEfsVWcVnxbPpcqzg6zYk-VXd4HbKEU"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register(
            "/",
        ) { pageCtx -> 
            _com_merkost_handpass_admin_pages_QueuePage()
        }
        ctx.router.register(
            "/feature-flags",
        ) { pageCtx -> 
            _com_merkost_handpass_admin_pages_FeatureFlagsPage()
        }
        ctx.router.register(
            "/images",
        ) { pageCtx -> 
            _com_merkost_handpass_admin_pages_ImagesPage()
        }
        ctx.router.register(
            "/listings",
        ) { pageCtx -> 
            _com_merkost_handpass_admin_pages_ListingsPage()
        }
        ctx.router.register(
            "/listings/{id}",
        ) { pageCtx -> 
            _com_merkost_handpass_admin_pages_ListingDetailPage()
        }
        ctx.router.register(
            "/logs",
        ) { pageCtx -> 
            _com_merkost_handpass_admin_pages_LogsPage()
        }
        ctx.router.register(
            "/moderation",
        ) { pageCtx -> 
            _com_merkost_handpass_admin_pages_ModerationRedirectPage()
        }
        ctx.router.register(
            "/partner-listings",
        ) { pageCtx -> 
            _com_merkost_handpass_admin_pages_PartnerListingsPage()
        }
        ctx.router.register(
            "/reports",
        ) { pageCtx -> 
            _com_merkost_handpass_admin_pages_ReportsRedirectPage()
        }
        ctx.router.register(
            "/stats",
        ) { pageCtx -> 
            _com_merkost_handpass_admin_pages_StatsPage()
        }
        ctx.router.register(
            "/users",
        ) { pageCtx -> 
            _com_merkost_handpass_admin_pages_UsersPage()
        }
        ctx.router.register(
            "/users/{id}",
        ) { pageCtx -> 
            _com_merkost_handpass_admin_pages_UserDetailPage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("admin-table-wrapper", com.merkost.handpass.admin.components.AdminTableWrapperStyle)
        ctx.theme.registerStyle("admin-table-wrapper-flush", com.merkost.handpass.admin.components.AdminTableWrapperFlushStyle)
        ctx.theme.registerStyle("admin-table-header", com.merkost.handpass.admin.components.AdminTableHeaderStyle)
        ctx.theme.registerStyle("admin-table-header-cell", com.merkost.handpass.admin.components.AdminTableHeaderCellStyle)
        ctx.theme.registerStyle("admin-table-sort-header", com.merkost.handpass.admin.components.AdminTableSortHeaderStyle)
        ctx.theme.registerStyle("admin-table-row", com.merkost.handpass.admin.components.AdminTableRowStyle)
        ctx.theme.registerStyle("command-palette-result-row", com.merkost.handpass.admin.components.CommandPaletteResultRowStyle)
        ctx.theme.registerStyle("menu-icon-button", com.merkost.handpass.admin.components.MenuIconButtonStyle)
        ctx.theme.registerStyle("admin-nav-item", com.merkost.handpass.admin.components.AdminNavItemStyle)
        ctx.theme.registerStyle("admin-nav-item-active", com.merkost.handpass.admin.components.AdminNavItemActiveStyle)
        ctx.theme.registerStyle("admin-theme-cycler-button", com.merkost.handpass.admin.components.AdminThemeCyclerButtonStyle)
        ctx.theme.registerStyle("admin-row-actions", com.merkost.handpass.admin.components.AdminRowActionsStyle)
        ctx.theme.registerStyle("admin-icon-button-base", com.merkost.handpass.admin.components.AdminIconButtonBaseStyle)
        ctx.theme.registerStyle("admin-icon-button-neutral", com.merkost.handpass.admin.components.AdminIconButtonNeutralStyle)
        ctx.theme.registerStyle("admin-icon-button-ok", com.merkost.handpass.admin.components.AdminIconButtonOkStyle)
        ctx.theme.registerStyle("admin-icon-button-danger", com.merkost.handpass.admin.components.AdminIconButtonDangerStyle)
        ctx.theme.registerStyle("seller-link", com.merkost.handpass.admin.pages.SellerLinkStyle)
        ctx.theme.registerStyle("log-target-link", com.merkost.handpass.admin.pages.LogTargetLinkStyle)
        ctx.theme.registerStyle("web-segment-button", com.merkost.handpass.sharedweb.components.WebSegmentButtonStyle)
        ctx.theme.registerStyle("web-badge", com.merkost.handpass.sharedweb.components.WebBadgeStyle)
        ctx.theme.registerStyle("web-drawer-backdrop", com.merkost.handpass.sharedweb.components.WebDrawerBackdropStyle)
        ctx.theme.registerStyle("web-drawer-panel", com.merkost.handpass.sharedweb.components.WebDrawerPanelStyle)
        ctx.theme.registerStyle("web-modal-backdrop", com.merkost.handpass.sharedweb.components.WebModalBackdropStyle)
        ctx.theme.registerStyle("web-modal-dialog", com.merkost.handpass.sharedweb.components.WebModalDialogStyle)
        ctx.theme.registerStyle("web-state-panel", com.merkost.handpass.sharedweb.components.WebStatePanelStyle)
        ctx.theme.registerStyle("web-button-base", com.merkost.handpass.sharedweb.components.WebButtonBaseStyle)
        ctx.theme.registerStyle("web-button-primary", com.merkost.handpass.sharedweb.components.WebButtonPrimaryStyle)
        ctx.theme.registerStyle("web-button-brand", com.merkost.handpass.sharedweb.components.WebButtonBrandStyle)
        ctx.theme.registerStyle("web-button-secondary", com.merkost.handpass.sharedweb.components.WebButtonSecondaryStyle)
        ctx.theme.registerStyle("web-button-outline", com.merkost.handpass.sharedweb.components.WebButtonOutlineStyle)
        ctx.theme.registerStyle("web-button-destructive", com.merkost.handpass.sharedweb.components.WebButtonDestructiveStyle)
        ctx.theme.registerStyle("web-button-ghost", com.merkost.handpass.sharedweb.components.WebButtonGhostStyle)
        ctx.theme.registerStyle("web-button-bare", com.merkost.handpass.sharedweb.components.WebButtonBareStyle)
        ctx.theme.registerStyle("web-button-ok", com.merkost.handpass.sharedweb.components.WebButtonOkStyle)
        ctx.theme.registerStyle("web-spinner", com.merkost.handpass.sharedweb.components.WebSpinnerStyle)
        ctx.theme.registerStyle("web-tab-pill", com.merkost.handpass.sharedweb.components.WebTabPillStyle)
        ctx.theme.registerStyle("web-tab-pill-active", com.merkost.handpass.sharedweb.components.WebTabPillActiveStyle)
        ctx.theme.registerStyle("web-tabs-row", com.merkost.handpass.sharedweb.components.WebTabsRowStyle)
        ctx.theme.registerStyle("web-card", com.merkost.handpass.sharedweb.components.WebCardStyle)
        ctx.theme.registerStyle("web-card-clickable", com.merkost.handpass.sharedweb.components.WebCardClickableStyle)
        ctx.theme.registerStyle("web-avatar", com.merkost.handpass.sharedweb.components.WebAvatarStyle)
        ctx.theme.registerStyle("web-toast", com.merkost.handpass.sharedweb.components.WebToastStyle)
        ctx.theme.registerStyle("web-toast-button", com.merkost.handpass.sharedweb.components.WebToastButtonStyle)
        ctx.theme.registerStyle("web-toast-action", com.merkost.handpass.sharedweb.components.WebToastActionStyle)
        ctx.theme.registerStyle("web-toast-dismiss", com.merkost.handpass.sharedweb.components.WebToastDismissStyle)
        ctx.theme.registerStyle("web-skeleton", com.merkost.handpass.sharedweb.components.WebSkeletonStyle)
        ctx.theme.registerStyle("web-pagination-cell", com.merkost.handpass.sharedweb.components.WebPaginationCellStyle)
        ctx.theme.registerStyle("web-pagination-active-cell", com.merkost.handpass.sharedweb.components.WebPaginationActiveCellStyle)
        ctx.theme.registerStyle("web-pagination-nav-button", com.merkost.handpass.sharedweb.components.WebPaginationNavButtonStyle)
        ctx.theme.registerStyle("web-field", com.merkost.handpass.sharedweb.components.WebFieldStyle)
        com.merkost.handpass.admin.initAdminStyles(ctx)
        com.merkost.handpass.admin.initAdminTokens(ctx)
        com.merkost.handpass.sharedweb.theme.initWebAnim(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        com.merkost.handpass.admin.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
